import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class TipoItem extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/TipoItemLookup" {...this.props} />;
  }
}

export default TipoItem;
